<template>
    <div class="register absolute">

        <div class="whiteBg">
            <div class="title">{{$t('message.register.register_account')}}</div>
            <div class="list">
                <!--<div class="item">
                    <div class="acea-row row-between-wrapper">
                        <svg t="1638322989702" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2368" width="200" height="200"><path d="M870.912 103.936H152.576c-47.616 0-86.528 38.912-86.528 86.528v526.848c0 47.616 38.912 86.528 86.528 86.528h224.256l111.616 111.616c6.656 6.656 14.848 9.728 23.552 9.728s16.896-3.072 23.552-9.728l111.616-111.616h224.256c47.616 0 86.528-38.912 86.528-86.528V190.464c-0.512-47.616-38.912-86.528-87.04-86.528z m19.968 613.376c0 10.752-8.704 19.968-19.968 19.968H640c-10.24-2.048-21.504 1.024-29.696 9.216L512 844.8l-98.304-98.304c-8.192-8.192-19.456-11.264-29.696-9.216H152.576c-10.752 0-19.968-8.704-19.968-19.968V190.464c0-10.752 8.704-19.968 19.968-19.968h718.336c11.264 0 19.968 8.704 19.968 19.968v526.848z" fill="#3E3A39" p-id="2369"></path><path d="M248.32 258.56c-16.896 0-30.72 13.312-31.744 30.208v317.44c0 17.408 14.336 31.744 31.744 31.744 17.408 0 31.744-14.336 31.744-31.744v-317.44c-1.024-16.896-14.848-30.208-31.744-30.208z" fill="#FA7268" p-id="2370"></path><path d="M515.072 378.368c-9.216-7.168-20.992-12.288-34.304-14.848-13.312-3.072-28.672-4.096-45.568-4.096-14.336 0-27.136 1.536-37.888 4.096-10.752 2.56-20.48 6.144-28.672 10.24-8.192 4.096-15.36 9.216-20.992 14.336-4.608 4.608-8.704 9.728-11.776 14.336-4.608 5.632-7.68 12.8-7.68 20.48 0 17.408 14.336 31.744 31.744 31.744 15.36 0 28.16-10.752 31.232-25.088l0.512-0.512c2.56-2.56 5.632-5.12 9.216-7.168 4.096-2.048 8.704-4.096 13.824-5.12 5.632-1.536 11.776-2.048 19.456-2.048s14.848 0.512 20.992 2.048c5.632 1.024 10.24 3.072 13.824 5.632 3.584 2.56 6.144 5.632 8.192 9.728 2.048 4.096 3.072 10.24 3.072 16.896v4.608l-48.64 4.608c-14.336 1.536-27.648 3.584-39.424 7.168-12.288 3.584-23.552 8.192-32.768 14.848-9.216 6.656-16.896 15.872-22.016 26.624s-8.192 24.064-8.192 39.424c0 11.776 2.048 22.528 5.632 32.768 3.584 9.728 9.216 18.944 16.384 26.112 7.168 7.168 15.872 13.312 26.112 16.896 10.24 4.096 22.016 6.144 35.328 6.144 15.872 0 30.72-3.584 44.544-10.24 8.704-4.608 17.408-9.728 25.6-15.872v9.728c0 16.896 13.824 30.72 30.72 30.72s30.72-13.824 30.72-30.72V450.048c0-16.896-2.56-31.232-7.168-43.008-5.12-11.776-12.288-21.504-22.016-28.672z m-34.816 167.424c-4.096 3.072-8.192 6.656-12.288 9.216-5.12 3.584-10.24 6.656-14.848 9.216-5.12 2.56-9.728 4.608-14.336 6.144-4.608 1.536-8.704 2.048-12.8 2.048-10.752 0-18.432-2.048-24.064-6.144-5.12-3.584-7.168-11.264-7.168-21.504 0-6.144 1.024-11.776 3.584-15.872 2.56-4.096 5.632-7.68 10.24-10.752 5.12-3.072 11.264-5.632 18.432-7.168 7.68-2.048 16.896-3.072 27.136-4.096l26.624-2.56v41.472zM799.232 384.512c-6.144-8.192-14.336-14.848-24.576-18.944-9.728-4.096-22.016-6.144-36.352-6.144-8.192 0-16.384 1.024-24.576 3.584-8.192 2.56-15.872 5.632-23.552 9.216-7.68 4.096-14.336 8.704-21.504 13.824l-6.144 4.608v-5.632 4.608c0-17.408-14.336-31.232-31.744-31.232s-31.744 13.824-31.744 31.232v-4.608 226.304c0 17.408 14.336 31.744 31.744 31.744s31.744-14.336 31.744-31.744V451.584c4.608-4.096 9.216-7.68 14.336-11.776 5.632-4.096 11.264-8.192 16.896-11.264 5.632-3.072 10.752-5.632 16.384-7.68 5.12-1.536 9.728-2.56 13.824-2.56 6.656 0 11.776 1.024 15.36 2.56 3.072 1.536 5.632 4.096 7.68 8.192 2.048 4.608 3.584 10.24 4.096 17.92 0.512 8.192 1.024 17.92 1.024 29.696v134.656c0 17.408 14.336 31.744 31.744 31.744s31.744-14.336 31.744-31.744V453.12c0-14.336-1.024-27.136-3.584-38.4-2.048-11.776-6.656-22.016-12.8-30.208z" fill="#3E3A39" p-id="2371"></path></svg>
                        <select style="width: 90%;" @change="changeLanguage($event)" v-model="language_active">
                            <option v-for="(item,index) in language" :key="index" :value="item.short">{{item.name}}</option>
                        </select>
                    </div>
                </div>-->
                <div class="item">
                    <div>
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-phone_"></use>
                        </svg>
                        <span class="chooseArea" @click="chooseArea()">
              <slot name="country_tel">+{{area}}</slot>
              <span><svg t="1566640213388" class="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="2787" width="18" height="18"><path
                      d="M512 721.5c-4.6 0-9.2-1.8-12.7-5.3l-383.1-383c-7-7-7-18.4 0-25.5s18.4-7 25.5 0L512 678.1l370.3-370.3c7-7 18.4-7 25.5 0 7 7 7 18.4 0 25.5l-383.1 383c-3.5 3.5-8.1 5.2-12.7 5.2z"
                      p-id="2788"></path></svg></span>
           </span>
                        <input type="number" v-model="account" :placeholder="$t('message.register.account')"/>
                    </div>
                </div>
                <!--<div class="item">
                    <div class="align-left">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-code_1"></use>
                        </svg>
                        <input type="text" v-model="captcha" placeholder="verification code" class="codeIput"/>
                        <button
                                class="code"
                                :disabled="disabled"
                                :class="disabled === true ? 'on' : ''"
                                @click="code"
                        >
                            {{ text }}
                        </button>
                    </div>
                </div>-->
                <div class="item">
                    <div class="align-left">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-code_1"></use>
                        </svg>
                        <input style="width: 2rem" type="text" v-model="v_code" :placeholder="$t('message.reset_pwd.verification_code')" class="codeIput"/>
                        <img style="width: 3.2rem;height: .8rem" :src="yz_img" @click="getVcode" class="code"/>
                    </div>
                </div>

                <div class="item">
                    <div>
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-code_"></use>
                        </svg>
                        <input type="password" v-model="password" :placeholder="$t('message.register.pwd')"/>
                    </div>
                </div>

                <div class="item">
                    <div>
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-code_"></use>
                        </svg>
                        <input type="password" v-model="password2" :placeholder="$t('message.register.con_pwd')"/>
                    </div>
                </div>
            </div>
            <div class="logon" @click="toregister">{{$t('message.register.register')}}</div>
            <div class="tip">
                {{$t('message.register.tip_account')}}
                <span @click="$router.push({ name: 'Login' })" class="font-color-blue">{{$t('message.login.login')}}</span>
            </div>
            <div class="tips">
                {{$t('message.register.by_click')}}
                <span @click="$router.push({ path: '/RegisterService' ,query:{id:10}})" class="font-color-blue">{{$t('message.register.privacy_policy')}}</span>

                <!--<span @click="$router.push({ name: 'RegisterService' ,query:{id:9}})" class="font-color-blue">Privacy Policy</span>-->

            </div>
            <div class="tips">
                <b style="color: red;font-size: 0.3rem">{{$t('message.register.tip_wrong')}}</b>
            </div>
        </div>
        <!-- <div class="bottom"></div> -->
    </div>
</template>

<script>
    import sendVerifyCode from "@mixins/SendVerifyCode";
    import {registerVerify, register_new, tp_captcha} from "@api/user";
    import {validatorDefaultCatch} from "@utils/dialog";
    import attrs, {required, alpha_num, chs_phone} from "@utils/validate";
    import cookie from "@utils/store/cookie";
    import dayjs from "dayjs";

    export default {
        name: "Register",
        data() {
            return {
                language_active:"vn",
                language:[
                    {short: "ar",name: "لغة عربية"},
                    // {short: "cn",name: "中文"},
                    {short: "de",name: "Deutsch"},
                    {short: "en",name: "English"},
                    {short: "es",name: "Español"},
                    {short: "fr",name: "Français"},
                    {short: "pt",name: "Português"},
                    {short: "py",name: "Русский"}
                ],
                type: 'register',
                account: '',
                v_code: '',
                yz_key: '',
                yz_img: '',
                // captcha: '',
                password: '',
                password2: '',
                area: '1',
                en: 'UnitedStatesofAmerica',
                bomb_btn: false,
            }
        },
        mixins: [sendVerifyCode],
        mounted: function () {
            this.area = this.localStorage.get("Area") ? this.localStorage.get("Area") : this.localStorage.get("default_country_code");
            this.en = this.localStorage.get("vn") ? this.localStorage.get("vn") : this.localStorage.get("default_country_en");
            this.getVcode();
            this.getlanguageActive();
        },
        watch: {
            $route() {
                // this.area = this.$route.params.tel?this.$route.params.tel:this.localStorage.get("default_country_code");
                this.area = this.localStorage.get("Area") ? this.localStorage.get("Area") : this.localStorage.get("default_country_code");
                this.en = this.localStorage.get("vn") ? this.localStorage.get("vn") : this.localStorage.get("default_country_en");
            },
        },
        methods: {
            getlanguageActive(){
                let lang = localStorage.getItem('lang')
                if (lang === null) {
                    this.language_active = 'vn'
                } else {
                    this.language_active = lang.replace(/\"/g, "")
                }
            },
            changeLanguage(e){
                this.localStorage.set("lang",e.target.value)
                this.$i18n.locale = e.target.value;
                // console.log(this.language_active)
            },
            chooseArea: function () {
                this.$router.push({path: '/selectCode'})
            },
            //注册
            async toregister() {
                var that = this;
                // const {account, captcha, password} = that;
                const {account, password, password2} = that;
                try {
                    await that
                        .$validator({
                            /*captcha: [
                                required(required.message("verification code")),
                                alpha_num(alpha_num.message("verification code"))
                            ],*/
                            password: [
                                required(required.message("password")),
                                attrs.range([6, 16], attrs.range.message("password")),
                                alpha_num(alpha_num.message("password"))
                            ],
                            password2: [
                                required(required.message("password")),
                                attrs.range([6, 16], attrs.range.message("password")),
                                alpha_num(alpha_num.message("password"))
                            ]
                        })
                        .validate({account, password, password2});
                } catch (e) {
                    return validatorDefaultCatch(e);
                }
                // console.log(that.area + that.account)
                // return
                let phone_new = that.area + that.account
                if (!/^\d+$/.test(phone_new.trim())) {
                    return this.$dialog.message(this.$t('message.register.msg_phone'));
                }
                register_new({
                    area: that.area,
                    en: that.en,
                    account: that.account,
                    yz_key: that.yz_key,
                    v_code: that.v_code,
                    // captcha: that.captcha,
                    password2: that.password2,
                    password: that.password,
                    spread: cookie.get("spread")
                })
                    .then(res => {
                        that.formItem = 1;
                        that.$store.commit("LOGIN", res.data.token, dayjs(res.data.expires_time));
                        // that.$router.replace({path: "/user"});
                        that.$router.replace({path: "/user/myPay"});
                        that.$dialog.success(res.msg);
                        /*setTimeout(() => {
                            that.$router.push({path: '/login'})
                        }, 500);*/
                    })
                    .catch(res => {
                        that.$dialog.error(res.msg);
                    });
            },
            getVcode: function () {
                let that = this
                tp_captcha().then(res => {
                    that.yz_key=res.data.key
                    that.yz_img=res.data.img
                    console.log(res)
                }).catch(res => {
                    console.log(res)
                });
            },
            //发送短信
            async code() {

                var that = this;

                if (!that.account) {
                    that.$dialog.error(this.$t('message.reset_pwd.msg_phone'));
                    return
                }
                /*if (!(/^63(0|9?[0-9]\d{9,10})$/.test(that.area + that.account))) {
                    console.log(that.account)
                    that.$dialog.error("Mobile phone number format error")
                    return
                }*/
                let query = {
                    phone: that.area + that.account,
                    type: that.type
                }
                if (this.bomb_btn) {
                    return
                }
                this.$dialog.loading.open('loading')
                this.bomb_btn = true
                registerVerify(query)
                    .then(res => {
                        this.$dialog.loading.close()

                        this.bomb_btn = false
                        that.$dialog.success(res.msg);
                        that.sendCode();
                    })
                    .catch(res => {
                        this.bomb_btn = false
                        this.$dialog.loading.close()

                        that.$dialog.error(res.msg);
                    });
            },
        },

    };
</script>

<style scoped>
    .tips {
        height: 1.1rem;
        text-align: center;
        /* line-height: 1.05rem; */
        font-size: 0.3rem;
        color: #cccccc;
    }
</style>
